import React, { createContext, useContext, useState, useEffect, useMemo } from 'react'
import useSWR from 'swr'
import { makePairNameValueObject } from '../../../utils/tools'
import axios from 'axios'

const ScreenersContext = createContext()

export const ScreenersContextProvider = ({ children }) => {
    const { data: sectorData } = useSWR(`/api/getAllSectors`)
    const { data: datasetsData } = useSWR(`/screener/getDatasetsOptions`)
    const {data: MicCodes} =  useSWR(`api/GetMicCodes`)

    const [ screeners, setScreeners ] = useState([])

    const sectors = useMemo(() => sectorData && makePairNameValueObject(sectorData.data, sectorData.data) ,[sectorData])

    const mic_codes = useMemo(()=> MicCodes && makePairNameValueObject(MicCodes.data,MicCodes.data),[MicCodes])

    useEffect(() => {
        axios.get(`/api/getUserScreeners`)
        .then(res => res.data)
        .then(res => setScreeners(res.screeners))
        return () => {}
    },[])

    const updatedScreenersList = (name, uuid) => {
        const update = screeners.map(screen => ({...screen, ...(screen.uuid === uuid && {name})}))
        setScreeners(update)
    }

    const handleCreateNewScreener = async () => {
        // const resJson = await fetch('/api/screener/createNewScreener', {
        //     method: 'POST',
        //     headers: { 'Content-Type': 'application/json' },
        //     body: JSON.stringify()
        // })
        const resJson = await axios({
            method: 'POST',
            url: '/api/screener/createNewScreener',
            data: {}
        })
        const res = await resJson.data
        setScreeners(state => [res.screener, ...state ])
    }

    const handleRemoveScreener = async (uuid) => {
        const resJson = await axios.get(`/api/screener/deleteScreener?uuid=${uuid}`)
        const res = await resJson.data
        res.status === 200 && setScreeners(state => state.filter(screenerData => screenerData.uuid !== uuid))
    }

    return (
        <ScreenersContext.Provider value={{
            screeners,
            updatedScreenersList,
            datasets: datasetsData?.data,
            sectors,
            mic_codes,
            handleCreateNewScreener,
            handleRemoveScreener,
        }}>
            { children}
        </ScreenersContext.Provider>
    )

}

export function useScreenersContext() {
    return useContext(ScreenersContext)
}